import TextOptionsQuestionTemplate from '~/pages/anatomyV2/libs/components/TextOptionsQuestionTemplate'
import { TEXT_OPTIONS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/textOptionsCorrectAnswers'
import {
  shoulderPainPNG,
  shoulderPainWEBP,
} from '~/pages/anatomyV2/shoulderPain/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 4

const OPTIONS = [
  {
    key: 'neckReferral',
    i18nKey: 'onboarding.shoulderPain.options.neckReferral',
  },
  { key: 'diaphragm', i18nKey: 'onboarding.shoulderPain.options.diaphragm' },
  { key: 'both', i18nKey: 'onboarding.shoulderPain.options.both' },
]

const ShoulderPainAnatomyV2 = (props: TPageProps) => (
  <TextOptionsQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.shoulderPain.title"
    questionImagePNG={shoulderPainPNG}
    questionImageWEBP={shoulderPainWEBP}
    questionImageAlt="Shoulder pain"
    options={OPTIONS}
    correctOptionKey={
      TEXT_OPTIONS_CORRECT_ANSWERS[PageId.SHOULDER_PAIN_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.shoulderPain.correctTitle"
    correctExplanationI18nKey="onboarding.shoulderPain.correctExplanation"
    incorrectTitleI18nKey="onboarding.shoulderPain.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.shoulderPain.incorrectExplanation"
    question="Why can your shoulder hurt when nothing's wrong"
  />
)

export default ShoulderPainAnatomyV2
